/**
 * Keys must match the flat boolean map returned as `feature_config` on `GET users/me/`.
 * Add a constant here whenever the backend exposes a new flag so call sites stay typed and grep-friendly.
 */
export const FEATURE_FLAGS = {
  /**
   * When true, double-clicking an exercise image opens the raw asset URL (otherwise only non-production builds allow this).
   */
  IMAGE_ASSET_DEBUG_OPEN: 'image_asset_debug_open',
  /**
   * When true, the exercise note area shows tabs to switch between the note and the AI chat placeholder.
   */
  CHAT_AI: 'chat_ai',
  /**
   * When true, debug mode is enabled.
   */
  TESTER: 'tester',
  /**
   * When true, the "W głowie" dashboard section and `/on-go` route are available.
   */
  ON_GO: 'on_go',
} as const;

export type FeatureFlagKey = typeof FEATURE_FLAGS[keyof typeof FEATURE_FLAGS];

/** Values from the API; extra string keys are allowed for forward compatibility. */
export type FeatureConfig = Partial<Record<FeatureFlagKey, boolean>>;
